import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
	name: 'regexHighlight',
	standalone: true,
})
export class RegexHighlightPipe implements PipeTransform {
	constructor(private sanitizer: DomSanitizer) {}

	transform(value: string, matchText: string): SafeHtml {
		return this.sanitizer.bypassSecurityTrustHtml(this.transformToHtml(value, matchText));
	}

	transformToHtml(value: string, matchText: string): string {
		if (!matchText) {
			return value;
		}

		matchText = this.removeRegexSpecialChars(matchText.trim());

		const matchParts = matchText.split(/\s+/);

		try {
			const regex = new RegExp(`(${matchParts.join('|')})`, 'gi');
			const result = value.replace(regex, `<mark>$1</mark>`);

			return result;
		} catch (e) {
			// Any error - just return the original value
			return value;
		}
	}

	private removeRegexSpecialChars(value: string) {
		value = value.replace(/([\^$.|?*+(\\[\]{}])/gi, '');
		return value;
	}
}
